import React, { Fragment } from 'react';
import { ListItemText, ListItemButton, List } from '@mui/material';
import { Link as RouterLink, useLocation } from 'react-router-dom';

import { SubMenuItem } from '../../interfaces';

export function SubMenuItems({ items }: { items: SubMenuItem[] }): JSX.Element {
  const location = useLocation();
  if (items.length > 0) {
    return (
      <List component='div' disablePadding>
        {items.map((link) => (
          <ListItemButton
            to={link.endpoint}
            component={RouterLink}
            key={link.title}
            selected={location.pathname.includes(link.endpoint)}
            sx={{ py: 0 }}
          >
            <ListItemText primary={link.title} />
          </ListItemButton>
        ))}
      </List>
    );
  }

  return <Fragment />;
}
